// Pulls every page of a paginated list so it can be exported in one go.
// fetchPage(page, limit) => rows | { data: rows } | Promise thereof.
// Stops at the first page that comes back short (these endpoints return no total).
export default async function fetchAllPages(fetchPage, { limit = 500, maxPages = 200 } = {}) {
  const all = [];
  for (let page = 1; page <= maxPages; page += 1) {
    const result = await fetchPage(page, limit);
    const rows = Array.isArray(result) ? result : Array.isArray(result?.data) ? result.data : [];
    // Guard against endpoints that ignore `page` and keep returning the same rows.
    const firstId = rows[0]?._id;
    if (page > 1 && firstId && all.some((row) => row?._id === firstId)) break;
    all.push(...rows);
    if (rows.length < limit) break;
  }
  return all;
}

// Shared date/time formatters for Excel exports.
export const formatExportDate = (value) => {
  if (!value) return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleDateString('en-GB');
};

export const formatExportDateTime = (value) => {
  if (!value) return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString('en-GB');
};
